__turbopack_context__.v({
  "Description": "LoyaltyCustomerModal-module-scss-module__rRPNVa__Description",
  "Form": "LoyaltyCustomerModal-module-scss-module__rRPNVa__Form",
  "Modal": "LoyaltyCustomerModal-module-scss-module__rRPNVa__Modal",
  "Title": "LoyaltyCustomerModal-module-scss-module__rRPNVa__Title",
});
